
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(46(07|63)|1371|2335|2980|5500|6672|8401|9703)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
